import { computed, inject, Injectable } from '@angular/core';
import {
  RsOverviewServerSideStateManager
} from '@rs-shared-lib/abstract-classes/rs-overview-state/rs-overview-server-side-state-manager';
import {
  RsPersistOverviewState
} from '@rs-shared-lib/abstract-classes/rs-overview-state/persistency/rs-persist-overview-state.decorator';
import { rsCountFilters } from '@rs-shared-lib/utils/count-filters/count-filters';
import { GetInboundInvoicesRequestParams, InvoiceItemResponse, InvoicesService } from '@api-client/mobipay';
import { DEFAULT_PAGE_SIZE_OPTIONS } from '@app/shared/constants';

@RsPersistOverviewState('InvoicesInboundState')
@Injectable({
  providedIn: 'root',
})
export class InboundInvoicesStateService extends RsOverviewServerSideStateManager<
  InvoiceItemResponse,
  GetInboundInvoicesRequestParams
> {
  public readonly filterCount = computed(() =>
    rsCountFilters(this.filters(), [
      'source',
      'validation',
      'type',
      ['sendDateFrom', 'sendDateTo'],
      ['invoiceDateFrom', 'invoiceDateTo'],
      ['deliveryDateFrom', 'deliveryDateTo'],
      'sellerSite',
      'sellerCompany',
      'buyerCompany',
      'status',
      'readStatus',
    ]),
  );

  private readonly invoicesService = inject(InvoicesService);
  constructor() {
    super({
      serviceMethod: (params) =>
        this.invoicesService.getInboundInvoices(params as GetInboundInvoicesRequestParams, 'response'),
      initialPagination: { pageIndex: 0, pageSize: 15 },
      config: {
        pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
      },
    });
  }
}

